<div data-testid="person-project-wizard">
    <ng-container [ngSwitch]="pageNumber">
        <div *ngSwitchCase="1">
            <div class="dialog-header">
                <span class="title">{{ 'aumico_create_person_project_dialog_select_person_title' | i18next }}</span>
                <span hamIconShapes class="close" icon="assets/hamIcons/x.svg" [variant]="'transparent'" [size]="'xs'" (click)="onCancel()"></span>
            </div>
            <div>
                <span class="description">{{ 'aumico_create_person_project_dialog_select_person_description' | i18next }}</span>
                <div class="input">
                    <input
                        hamSearchDropDown
                        [options]="personsList"
                        [optionKeys]="['name']"
                        returnKey="_id"
                        [label]="'aumico_create_person_project_dialog_select_person_input_title' | i18next"
                        [returnObject]="true"
                        [placeholder]="'aumico_create_person_project_dialog_select_person_input_placeholder' | i18next"
                        [formControl]="personControl"
                        [multiple]="false"
                        class="searchuserinput"
                        data-testid="wizard-person-search"
                    />
                </div>
            </div>
            <div class="footer">
                <div class="question-number">
                    {{ pageLabel }} {{ 'aumico_create_project_dialog_of' | i18next }} {{ totalNumberOfPages }}
                </div>
                <div class="footer-buttons">
                    <ham-button size="xs" outline="true" data-testid="wizard-cancel" (buttonClick)="onCancel()">
                        {{ 'aumico_create_project_dialog_cancel_button' | i18next }}
                    </ham-button>
                    <ham-button size="xs" data-testid="wizard-next" [disabled]="personControl.value == null" (buttonClick)="next()">
                        {{ 'aumico_create_project_dialog_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="2">
            <div class="dialog-header">
                <span class="title">{{ 'aumico_create_person_project_dialog_select_period_title' | i18next }}</span>
                <span hamIconShapes class="close" icon="assets/hamIcons/x.svg" [variant]="'transparent'" [size]="'xs'" (click)="onCancel()"></span>
            </div>
            <div>
                <span class="description">{{ 'aumico_create_person_project_dialog_select_period_description' | i18next }}</span>
                <div class="input">
                    <input
                        hamSimpleDropDown
                        [label]="'aumico_create_person_project_dialog_select_period_input_label' | i18next"
                        [options]="yearOptions"
                        [optionKeys]="['name']"
                        returnKey="id"
                        [returnObject]="true"
                        [placeholder]="'aumico_create_person_project_dialog_select_period_input_placeholder' | i18next"
                        [formControl]="yearControl"
                        data-testid="wizard-year"
                    />
                </div>
            </div>
            <div class="footer">
                <div class="question-number">
                    {{ pageLabel }} {{ 'aumico_create_project_dialog_of' | i18next }} {{ totalNumberOfPages }}
                </div>
                <div class="footer-buttons">
                    <ham-button *ngIf="personId == null" size="xs" outline="true" (buttonClick)="goBack()">
                        {{ 'aumico_create_project_dialog_back_button' | i18next }}
                    </ham-button>
                    <ham-button *ngIf="personId != null" size="xs" outline="true" data-testid="wizard-cancel" (buttonClick)="onCancel()">
                        {{ 'aumico_create_project_dialog_cancel_button' | i18next }}
                    </ham-button>
                    <ham-button
                        size="xs"
                        [disabled]="selectedYear == null"
                        data-testid="wizard-create"
                        (buttonClick)="submit()"
                    >
                        {{ 'aumico_create_project_dialog_submit_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
